import { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import About from "../components/About";
import Courses from "../components/Courses";
import WhyUs from "../components/WhyUs";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import FooterBanner from "../components/FooterBanner";

function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
useEffect(() => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (user?.role === "admin") {
    navigate("/home-settings");  // 🚀 redirect admin
  }
}, []);
  // ✅ receive course ID
const handleEnroll = (id, slug) => {
  navigate(`/course/${id}/${slug}`);

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

  const location = useLocation();

useEffect(() => {
  const section = location.pathname.replace("/", "");

  if (section) {
    const el = document.getElementById(section);

    if (el) {
      setTimeout(() => {
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  } else {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}, [location]);

  return (
    <div className="App">
      <div className="si-root">
        <Navbar scrolled={scrolled} />
        <Hero />
        <section id="about">
          <About />
        </section>

        <section id="why-swiftintelli">
          <WhyUs />
        </section>
        <section id="our-courses">
          <Courses onEnrollNow={handleEnroll} />
        </section>

        <section id="contact-us">
          <Footer />
        </section>
      </div>
    </div>
  );
}

export default HomePage;
